const cardData = {
	uid: null,
	data: {
		active: null, // boolean
		userRef: null, // string => userPathReference
		displayName: null,
		fullName: null,
		orgId: null,
		role: null, // number => 1 || 2 || 3 (ie, Store Mgr, Rent, Customer)
		subsHistoryItems: 0,
		subsHistory: [], // array of objects to collect expired subscriptions (subsItems expired)
		subsItems: null, // number => 1 || 2 || 3
		subsItem1: {
			dogRef: null, // string => dogPathReference
			DogName: null,
			DogBreed: null, // string => name from breeds collection
			DogSize: null, // number => 1 || 2 || 3 || 4 || 5 || 6
			DogHair: null, // number => 1 || 2 || 3
			WashPgm: null, // string => "11" -> "99"
			WashAct: null, // number => 0 -> WashTot
			WashTot: null, // number => 4 -> Tot.Washes per Year || before Exp.Date
			SubsName: null, // string => subs - product.name
			DueDate: null, // string => DD/MM/YYYY
		},
		subsItem2: {
			dogRef: null, // string => dogPathReference
			DogName: null,
			DogBreed: null, // string => name from breeds collection
			DogSize: null, // number => 1 || 2 || 3 || 4 || 5 || 6
			DogHair: null, // number => 1 || 2 || 3
			WashPgm: null, // string => "11" -> "99"
			WashAct: null, // number => 0 -> WashTot
			WashTot: null, // number => 4 -> Tot.Washes per Year || before Exp.Date
			SubsName: null, // string => subs - product.name
			DueDate: null, // string => DD/MM/YYYY
		},
		subsItem3: {
			dogRef: null, // string => dogPathReference
			DogName: null,
			DogBreed: null, // string => name from breeds collection
			DogSize: null, // number => 1 || 2 || 3 || 4 || 5 || 6
			DogHair: null, // number => 1 || 2 || 3
			WashPgm: null, // string => "11" -> "99"
			WashAct: null, // number => 0 -> WashTot
			WashTot: null, // number => 4 -> Tot.Washes per Year || before Exp.Date
			SubsName: null, // string => subs - product.name
			DueDate: null, // string => DD/MM/YYYY
		},
	}	
};

export { cardData }